require('../scss/main.scss');

require('es6-promise').polyfill();
require('babel-polyfill');

import es6Find from './app/polyfills';
es6Find.polyfill();

if (process.env.NODE_ENV === 'production') {
	//document.domain = require("Config").domain;
	Raven.config(
		'https://fdfbba25c9ca4bd1aafdbcaf256fa5f5@sentry.io/146098'
	).install();
}

import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';

import store from './app/store';
import routes from './routes';

const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
	<Provider store={store}>
		<Router routes={routes} history={history} />
	</Provider>,
	document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/js/main.js